<template>
    <content-layout>
        <template slot="sidebar-overlay">
            <ui-sidebar-overlay></ui-sidebar-overlay>
        </template>
        <template slot="sidebar">
            <ui-sidebar>
                <ui-navigation :nav-items="items"></ui-navigation>
            </ui-sidebar>
        </template>
        <template slot="header">
            <ui-header></ui-header>
        </template>
        <template slot="footer">
            <ui-footer></ui-footer>
        </template>
        <template slot="content">
            <router-view></router-view>
        </template>
    </content-layout>
</template>

<script>
    import ContentLayout from './ContentLayout';
    import SidebarOverlay from '../utils/SidebarOverlay';
    import Sidebar from '../navigation/sidebar/Sidebar';
    import Navigation from '../navigation/sidebar/NavItem';
    import Footer from '../utils/Footer';
    import Header from '../utils/Header';

    export default {
        props: {
            items: Array
        },
        created(){
            this.loadProject();
        },
        components: {
            'content-layout': ContentLayout,
            'ui-sidebar-overlay': SidebarOverlay,
            'ui-sidebar': Sidebar,
            'ui-navigation': Navigation,
            'ui-footer': Footer,
            'ui-header': Header
        }
    }
</script>
